import React from 'react';
import './OurHotel.css'
const OurHotel = () => {
  return (
    <div className='OurHotel' id='about'>
      <h1>Moonside Rooms Skegness</h1>
      <div class="line"></div>
      <p id='welcome'>Welcome to Moonside Rooms, a cozy 2-star hotel with a self-check-in, located in the heart of Lincolnshire, just 400 yards from Winthorpe Beach and 400 Yeards from Skegness Butlins. We're also 200 Yards from Skegness Railway Station and 310 Yards from Skegness Beach. Explore nearby attractions like Skegness Pier, Tower Gardens, and the Clock Tower. Humberside Airport is 42 miles away. Moonside Rooms is a non-smoking property, offering a peaceful stay with a 9.0 rating for romantic getaways.</p>
    </div>
  );
};

export default OurHotel;
